import { Heading } from "@stellar/design-system";

import { MultisigAuditCard } from "@/components/MultisigAuditCard";
import { RecoveryAuditCard } from "@/components/RecoveryAuditCard";
import { SectionHeader } from "@/components/SectionHeader";
import { TransactionNoticeCard } from "@/components/TransactionNoticeCard";
import { WalletStatementCard } from "@/components/WalletStatementCard";

import { MULTISIG_FEATURE_FLAGS } from "@/constants/multisigFeatureFlags";

import { useIsMultisigFeatureEnabled } from "@/hooks/useIsMultisigFeatureEnabled";

export const Reports = () => {
  const isStatusDashboardEnabled = useIsMultisigFeatureEnabled(
    MULTISIG_FEATURE_FLAGS.STATUS_DASHBOARD,
  );

  return (
    <>
      <SectionHeader>
        <SectionHeader.Row>
          <SectionHeader.Content>
            <Heading as="h2" size="sm">
              Reports / Exports
            </Heading>
          </SectionHeader.Content>
        </SectionHeader.Row>
      </SectionHeader>

      <div className="CardStack">
        <WalletStatementCard />
        <TransactionNoticeCard />
        <RecoveryAuditCard />
        {isStatusDashboardEnabled && <MultisigAuditCard />}
      </div>
    </>
  );
};
